import CONTACT_STATES from 'lib/common/constants/contactStates';

import TTask from 'lib/common/types/Task';
import connectGetter from 'lib/common/utils/connectGetter';

import THandleContactChange from '../types/HandleContactChange';

const registerPauseTaskEvents = (
  latestContact: connect.Contact,
  getTasks: () => TTask[],
  handleContactChange: THandleContactChange
) => {
  const existingTask = getTasks().find((existingTask: TTask) => existingTask.taskId === latestContact.contactId);

  if (!existingTask) {
    return;
  }

  const contactType = connectGetter(latestContact, 'getType');
  const contactState = connectGetter(latestContact, 'getState')?.type;

  const currentTaskStatus = existingTask?.status;
  const isPausedContact = contactState === connect.ContactStateType.PAUSED;
  const isConnectedContact = contactState === connect.ContactStateType.CONNECTED;
  const supportsPausing = contactType === connect.ContactType.TASK || contactType === connect.ContactType.EMAIL;
  const isDraftStatus = currentTaskStatus === CONTACT_STATES.DRAFT;

  if (!supportsPausing || isDraftStatus) {
    return;
  }

  if (isPausedContact && currentTaskStatus !== CONTACT_STATES.PAUSED) {
    return handleContactChange({ contact: latestContact, status: CONTACT_STATES.PAUSED });
  }

  if (isConnectedContact && currentTaskStatus === CONTACT_STATES.PAUSED) {
    return handleContactChange({ contact: latestContact, status: CONTACT_STATES.CONNECTED });
  }
};

export default registerPauseTaskEvents;
